import { createBrowserRouter } from "react-router-dom";
import HomePage from "../pages/HomePage";
import authRoutes from "./authRoutes";
import NotFound from "../pages/NotFound";
import driverRoutes from "./driverRoutes";
import ownerRoutes from "./ownerRoutes";
import AuthLayout from "../layout/AuthLayout";
import CargoDetailPage from "../pages/CargoDetailPage";
import PublicWelcome from "../pages/PublicWelcome";

const index = createBrowserRouter([
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/welcome",
    element: <PublicWelcome />,
  },
  {
    path: "/orders/:id",
    element: <AuthLayout />,
    children: [{ index: true, element: <CargoDetailPage /> }],
  },
  {
    path: "/*",
    element: <NotFound />,
  },
  ...authRoutes,
  ...driverRoutes,
  ...ownerRoutes,
]);

export default index;
